module.exports = __webpack_public_path__ + "static/garmin_run_coach_mobile-d8cebf2c1a19befdc913fa46d23b7623.jpg";